import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tous-devis-negoce',
  templateUrl: './tous-devis-negoce.component.html',
  styleUrls: ['./tous-devis-negoce.component.scss']
})
export class TousDevisNegoceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
